<template>
  <FeatureDetailPage feature-key="expenses" />
</template>
